module.exports = __webpack_public_path__ + "img/logoSlide5.3141a0b2.png";